import type { FC } from 'react';

import type { AssetsSegmentSchemaWithIdPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';

import {
  SEGMENT_TYPE_COMMENT,
  SEGMENT_TYPE_GENERIC,
  SEGMENT_TYPE_TAG,
} from '../comment_form/constants';
import { SegmentValueComment } from './segment_value_comment';

type Props = {
  segment: AssetsSegmentSchemaWithIdPatched;
};

export const SegmentValue: FC<Props> = ({ segment }) => {
  if (segment.segment_type === SEGMENT_TYPE_COMMENT) {
    return (
      <SegmentValueComment
        segment={segment}
        value={segment.segment_text ?? ''}
      />
    );
  }

  if (segment.segment_type === SEGMENT_TYPE_TAG) {
    // TODO implement tag support?
    // return (
    //   <SegmentValueTag
    //     onLayoutChanged={onLayoutChanged}
    //     value={segment.metadata?._gcvi_tags ?? []}
    //   />
    // );
  }

  if (segment.segment_type === SEGMENT_TYPE_GENERIC) {
    // TODO implement metadata support?
    // return (
    //   <SegmentValueGeneric
    //     segment={segment}
    //     onLayoutChanged={onLayoutChanged}
    //     value={segment.metadata ?? {}}
    //   />
    // );
  }

  return null;
};
